import { render, staticRenderFns } from "./KaiPanel.vue?vue&type=template&id=447ba1fa&scoped=true&"
import script from "./KaiPanel.vue?vue&type=script&lang=ts&"
export * from "./KaiPanel.vue?vue&type=script&lang=ts&"
import style0 from "./KaiPanel.vue?vue&type=style&index=0&id=447ba1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ba1fa",
  null
  
)

export default component.exports